import Table, { ColumnsType } from 'antd/es/table';
import React from 'react'
import { AEORatesTypesOptionList, EmployeePayFrequency, EmployeePayFrequencyOptionList, IAEOThresholds } from '../../Services/PayrollYearlySettingsService';
import Link from 'antd/es/typography/Link';
import { EditTwoTone, EyeFilled, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Row, Col, Button, Select, Spin } from 'antd';
import { ListParams } from './PayrollYearlySettingsDetails';

interface iAEORatesProps {
  isViewOnly: boolean;
  OnCancelClick: () => void;
  listParams: ListParams;
  setListParams: React.Dispatch<React.SetStateAction<ListParams>>;
  setDialog: React.Dispatch<
    React.SetStateAction<{
      type: string;
      params: any;
    }>
  >;
  aeoRatesListType: IAEOThresholds[] | []
}

const AEORates = ({
  isViewOnly = false,
  OnCancelClick,
  listParams,
  setListParams,
  setDialog,
  aeoRatesListType,
}: iAEORatesProps) => {
  const [loading, setLoading] = React.useState(false);
  const [payFrequencyFilter, setPayFrequencyFilter] = React.useState<number[]>([]);
  const [aeoRatesListTypeData, setNIThersholdsListData] = React.useState(
    aeoRatesListType
  );
  const [pagination, setPagination] = React.useState({
    current: 1,
    pageSize: 15,
  });

  React.useEffect(() => {
    if (aeoRatesListType?.length > 0) {

      const hasPayFreq =
        Array.isArray(payFrequencyFilter) &&
        payFrequencyFilter.length > 0;

      const filteredData = hasPayFreq
        ? aeoRatesListType.filter((item: IAEOThresholds) =>
          payFrequencyFilter.includes(item.payFrequency)
        )
        : aeoRatesListType;

      setNIThersholdsListData(filteredData);
    } else {
      setNIThersholdsListData([]);
    }
  }, [aeoRatesListType, payFrequencyFilter]);

  const columns: ColumnsType<any> = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      width: "4%",
      render: (_: any, record: any, index: any) => <p>{(pagination.current - 1) * pagination.pageSize + index + 1}</p>,
    },
    {
      title: "Pay Frequency",
      dataIndex: "payFrequency",
      key: "PayFrequency",
      width: "9%",
      render: (_: any, record: any, index: any) => (
        <p>{EmployeePayFrequency[record?.payFrequency]}</p>
      ),
    },
    {
      title: "Lower Limit",
      dataIndex: "lowerLimit",
      key: "LowerLimit",
      width: "20%",
      sorter: (a, b) => a.lowerLimit - b.lowerLimit,
      showSorterTooltip: false,
    },
    {
      title: "Higher Limit",
      dataIndex: "higherLimit",
      key: "HigherLimit",
      width: "20%",
      sorter: (a, b) => a.higherLimit - b.higherLimit,
      showSorterTooltip: false,
    },
    {
      title: "Rate",
      dataIndex: "rate",
      key: "Rate",
      width: "20%",
      sorter: (a, b) => a.rate - b.rate,
      showSorterTooltip: false,
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "Id",
      width: "3%",
      render: (_: any, record: any, index: any) => (
        <Link
          className="edit-btn"
          onClick={() => {
            setDialog({ type: "AddAEORates", params: { record: record } });
          }}
        >
          {
            isViewOnly ?
              <EyeFilled />
              :
              <EditTwoTone />
          }
        </Link>
      ),
    },
  ];

  return (
    <>
      <Row
        className="p-3"
        style={{
          backgroundColor: "white",
          paddingTop: 2
        }}
      >
        <Col span={24}>
          <Row gutter={[8, 8]} className="pb-3"
            align="middle">
            {/* ================= ADD ================= */}
            <Col xs={24} sm={8} md={5} lg={4} xl={3} xxl={2}>
              {
                !isViewOnly ?
                  <Button
                    block
                    type="primary"
                    className="add-btn"
                    onClick={() => setDialog({ type: "AddAEORates", params: {} })}
                  >
                    <PlusOutlined />
                    Add Item
                  </Button>
                  : null
              }
            </Col>
            {/* ================= DATE ================= */}
            <Col xs={24} sm={16} md={{ span: 8, offset: 1 }} lg={{ span: 8, offset: 4 }} xl={{ span: 6, offset: 8 }} xxl={{ span: 4, offset: 13 }}>
              <Select
                mode="multiple"
                allowClear
                placeholder="Select Pay Frequency"
                maxTagCount="responsive"
                style={{ width: "100%" }}
                onChange={(value, op) => {
                  setPayFrequencyFilter(value as number[]);
                }}
                filterOption={(input, option) =>
                  (option?.label?.toString() ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={EmployeePayFrequencyOptionList}
              />
            </Col>
            {/* ================= NICategory List ================= */}
            <Col xs={24} sm={24} md={10} lg={8} xl={7} xxl={5}>
              <Select
                className="line-height-28"
                style={{
                  height: "22px !important",
                  width: "100%",
                  lineHeight: "22px !important",
                }}
                value={listParams?.aeoRates}
                placeholder="Select AEO Rates Type"
                options={AEORatesTypesOptionList}
                onChange={(val) => setListParams({ ...listParams, aeoRates: val })}
              />
            </Col>
          </Row>
        </Col>

        <Col span={24} style={{ maxHeight: window.innerHeight - 350, overflowY: "scroll" }}>
          <Table
            dataSource={aeoRatesListTypeData}
            columns={columns}
            size="small"
            className="border-top-table"
            loading={{
              spinning: loading,
              indicator: (
                <Spin
                  indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />}
                />
              ),
            }}
            pagination={{
              defaultPageSize: 15,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              showSizeChanger: true,
              total: aeoRatesListTypeData?.length,
              pageSizeOptions: ["15", "25", "50", "100"],
              onChange: (page, pageSize) =>
                setPagination({ current: page, pageSize }),
            }}
            // pagination={{
            //   showTotal: (total, range) =>
            //     `${range[0]}-${range[1]} of ${total} items`,
            //   current: 1,
            //   pageSize: aeoRatesListTypeData?.length,
            //   showSizeChanger: true,
            //   total: aeoRatesListTypeData?.length,
            //   position: ['bottomRight'],
            //   style: { position: "sticky", right: 0, bottom: 0, backgroundColor: "white" },
            //   pageSizeOptions: ["15", "25", "50", "100"],
            // }}
            scroll={{ x: 700 }}
          />
        </Col>
      </Row>
    </>
  )
}

export default AEORates